class VariantButton extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const self = this;
    self.addEventListener("click", function (e) {
      //debugger;
      if(e.target.getAttribute("type") === "radio"){
        //debugger;
        self.updateSelectedVariant(e);
      }
      
    });

    /*self.addEventListener("focusin", (e) => {
      if(e.target.getAttribute("type") === "radio" && e.target.getAttribute("checked") != "checked" && e.target.name == "Size"){
        debugger;
        self.updateSelectedVariant(e);
      }
    
    });*/
    self.addEventListener("keydown", function (e) {
      if(e.which === 13){ 
        console.log("test1*********");
        //debugger;
        self.updateSelectedVariant(e);
      }
    });
    //debugger;
  }

  async updateVariantKeyHandler(){ 
    document.querySelectorAll('fieldset.swatch_options[name=Size]').forEach(sizeGroup =>{
     // console.log("found sizeGroup: ", sizeGroup); 
      const inputs = Array.from(sizeGroup.querySelectorAll('input[type="radio"]'));
      //console.log("inputs: ", inputs);  
      inputs.forEach((input, i) => {
        input.addEventListener('keydown', (e) => {
          const arrowKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Enter'];
          if (!arrowKeys.includes(e.key)) return;

          e.preventDefault(); // stops native browser auto-select-on-arrow

          let nextIndex;

          if (e.key === 'Enter' || e.key === ' ') {
            console.log("hitting the enter");
            e.preventDefault(); // stop Enter from submitting the form
            nextIndex = i;
            console.log("index: ", nextIndex);
            
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true })); // re-trigger your variant logic
          }

          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            nextIndex = (i - 1 + inputs.length) % inputs.length;
            console.log("hitting arrow key. nextIndex1: ", nextIndex);
          } else if(e.key === 'ArrowRight' || e.key === 'ArrowDown'){
            nextIndex = (i + 1) % inputs.length;
             console.log("hitting arrow key. nextIndex2: ", nextIndex);
          }

          

          //console.log("element focused: ", inputs[nextIndex]);
          // just move focus, don't check it
          console.log("the input: ", inputs[nextIndex]);
          
          setTimeout(function(){
            inputs[nextIndex].focus();
          }, 200);
          
        });
      });
    });

    document.querySelectorAll('fieldset.swatch_options[name=Color]').forEach(colorGroup =>{
      //console.log("found colorGroup: ", colorGroup); 
      const inputs = Array.from(colorGroup.querySelectorAll('input[type="radio"]'));
      //console.log("inputs: ", inputs);  
      inputs.forEach((input, i) => {
        input.addEventListener('keydown', (e) => {
          const arrowKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Enter'];
          if (!arrowKeys.includes(e.key)) return;

          e.preventDefault(); // stops native browser auto-select-on-arrow

          let nextIndex;

          if (e.key === 'Enter' || e.key === ' ') {
            console.log("hitting the enter");
            e.preventDefault(); // stop Enter from submitting the form
            nextIndex = i;
            console.log("index: ", nextIndex);
            
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true })); // re-trigger your variant logic
          }

          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            nextIndex = (i - 1 + inputs.length) % inputs.length;
            console.log("hitting arrow key. nextIndex1: ", nextIndex);
          } else if(e.key === 'ArrowRight' || e.key === 'ArrowDown'){
            nextIndex = (i + 1) % inputs.length;
             console.log("hitting arrow key. nextIndex2: ", nextIndex);
          }

          

          //console.log("element focused: ", inputs[nextIndex]);
          // just move focus, don't check it
          console.log("the input: ", inputs[nextIndex]);
          
          setTimeout(function(){
            inputs[nextIndex].focus();
          }, 200);
          
        });
      });
    });

    document.querySelectorAll('fieldset.swatch_options[name=Title]').forEach(priceGroup =>{
      //console.log("found colorGroup: ", priceGroup); 
      const inputs = Array.from(priceGroup.querySelectorAll('input[type="radio"]'));
      //console.log("inputs: ", inputs);  
      inputs.forEach((input, i) => {
        input.addEventListener('keydown', (e) => {
          const arrowKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Enter'];
          if (!arrowKeys.includes(e.key)) return;

          e.preventDefault(); // stops native browser auto-select-on-arrow

          let nextIndex;

          if (e.key === 'Enter' || e.key === ' ') {
            console.log("hitting the enter");
            e.preventDefault(); // stop Enter from submitting the form
            nextIndex = i;
            console.log("index: ", nextIndex);
            
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true })); // re-trigger your variant logic
          }

          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            nextIndex = (i - 1 + inputs.length) % inputs.length;
            console.log("hitting arrow key. nextIndex1: ", nextIndex);
          } else if(e.key === 'ArrowRight' || e.key === 'ArrowDown'){
            nextIndex = (i + 1) % inputs.length;
             console.log("hitting arrow key. nextIndex2: ", nextIndex);
          }

          

          //console.log("element focused: ", inputs[nextIndex]);
          // just move focus, don't check it
          console.log("the input: ", inputs[nextIndex]);
          
          setTimeout(function(){
            inputs[nextIndex].focus();
          }, 200);
          
        });
      });
    });
  }

  async updateSelectedVariant({ currentTarget }) {
    // --- BIS FIX (Change 5): click and focusin can both fire for the same
    // interaction (clicking a <label> fires a synthetic click on its radio
    // AND moves focus onto it), causing two overlapping calls to this
    // function. The second call operates on an already-removed DOM node
    // and throws on `variantElement.parentNode.insertBefore(...)`, which
    // aborts that call before it ever reaches updateVariantState/BIS logic.
    // Guard against concurrent runs so only one swap executes at a time.
    //console.log("currentTarget", currentTarget);
    if (this._updatingVariant) return;
    this._updatingVariant = true;
    try {
      if (window._observer_ATC) {
        window._observer_ATC.disconnect();
      }
      //debugger;
      this.disableCartButton();
    const clickedInput = currentTarget.querySelector('input[type="radio"]');
    const clickedLabel = currentTarget.querySelector('label');
    //debugger;
    clickedInput.setAttribute("checked", true);
    // Clear size display immediately if we're switching colors
    
    const windowScroll = window.scrollY;
    const { sectionId } = this.dataset;
    const id = clickedInput.id;
    const productURL = clickedInput.dataset.optionUrl;
    const optionID = clickedInput.dataset.optionId;
    const variantElement = document.querySelector(
      "[data-dynamic-variants-enabled]"
    );
    const imageElement = document.querySelector(
      "[data-dynamic-product-gallery]"
    );
    const productElement = document.querySelector(".product-section");
    const variantJSON = JSON.parse(
      document.querySelector(`[data-resource="${id}"]`).innerText
    );


    let newVariantId = false;
    if (productURL == "" && variantJSON != null) {
      newVariantId = variantJSON.id;
    } else if(productURL) {
      newVariantId = clickedInput.dataset.variantId;
    }
    let params = `section_id=${sectionId}`;
    let url = !productURL ? location.pathname : productURL;
    if (newVariantId) {
      params += `&variant=${newVariantId}`;
    } else {
      const productCheckedOptions = document.querySelectorAll(
        ".variant-wrapper fieldset input:checked"
      );
      let needsOptionValues = true;
      productCheckedOptions.forEach((option) => {
        if (option.dataset.optionUrl == "") {
          needsOptionValues = false;
        }
      });
      if (needsOptionValues) {
        const selectedOptionValues = Array.from(productCheckedOptions)
          .map((element) => element.dataset.optionId)
          .join(",");
        params += `&option_values=${selectedOptionValues}`;
      }
    }
    const res = await fetch(`${url}?${params}`);
    const text = await res.text();
    const html = new DOMParser().parseFromString(text, "text/html");
    const newProductElement = html.querySelector(".product-section");
    //debugger;
    const newProductKiwiJSON = JSON.parse(html.querySelector('#productKiwiJSON').innerText);
    //debugger;
    const newVariantElement = html.querySelector(
      "[data-dynamic-variants-enabled]"
    );
    const newImageElement = html.querySelector(
      "[data-dynamic-product-gallery]"
    );
    
    if (productURL) {

      if(currentTarget.classList.contains("ColorSwatch")){
        //console.log("new: ", currentTarget.getAttribute("data-option-url"));
        //console.log("orginal: ", window.location.pathname);
        await this.refreshProductData(currentTarget.getAttribute("data-option-url"));
      }
      
      // --- BIS FIX (Change 2): capture the BIS button before the old
      // container is torn out, so it survives the cross-product swap.
      const accurateInventory = window.productData.variants.find(v => v.inventory_quantity === 0);
      //console.log("accurateInventory", accurateInventory);
      if(accurateInventory && !accurateInventory.Tags.includes("NBIS")){
        this.showSoldOutInfo();
      }else{
        this.hideSoldOutInfo();
      }


      //const bisButton = productElement.querySelector('#BIS_trigger');
      const sizeSoldOutInfo = productElement.querySelector('.size-sold-out-info');
      if (productElement.parentNode) {
        productElement.parentNode.insertBefore(newProductElement, productElement);
        const newLabel = newProductElement.querySelector('label[for="' + clickedInput.id + '"]');
       //console.log("newLabel: ", newLabel);
        //debugger;
        if(newLabel){
          //debugger;
          newLabel.focus();
        }
        productElement.remove();
      }

      // --- BIS FIX (Change 2 cont.): re-attach it if the freshly fetched
      // server HTML didn't already include it.
      /*if (bisButton && !newProductElement.querySelector('#BIS_trigger')) {
        const newForm = newProductElement.querySelector('[data-product-form]');
        if (newForm){
          newForm.appendChild(bisButton);
        } 
      }*/
      if (sizeSoldOutInfo) {
        const existingNew = newProductElement.querySelector('.size-sold-out-info');
        if (existingNew) {
          // replace the server's default node with the one carrying your state
          existingNew.replaceWith(sizeSoldOutInfo);
        } else {
          const newForm = document.querySelector('.swatch_options[name="Size"]');
          console.log("newForm: ", newForm);
          if (newForm) newForm.appendChild(sizeSoldOutInfo);
        }
      }
      
      const scriptToReload = document.querySelector("script[src*=product-bundle]");
      if (scriptToReload) {
        const newScript = document.createElement('script');
        newScript.src = scriptToReload.src;
        document.head.appendChild(newScript);
        scriptToReload.remove();
      }
      KiwiSizing.data = newProductKiwiJSON;
    } else {
      //console.log("newVariantElement: ", newVariantElement);
      //console.log("variantElement: ", variantElement);
      // --- BIS FIX (Change 1): capture the BIS button before the old
      // container is torn out, so it survives the same-product (size) swap.
     // const bisButton = variantElement.querySelector('#BIS_trigger');
      const sizeSoldOutInfo = productElement.querySelector('.size-sold-out-info');
      //console.log("sizeSoldOutInfo: ", sizeSoldOutInfo);
      

      variantElement.parentNode.insertBefore(newVariantElement, variantElement);
      const newLabel = newVariantElement.querySelector('label[for="' + clickedInput.id + '"]');
      //console.log("newLabel: ", newLabel);
      if(newLabel && !newLabel.classList.contains("disabled")){
        //debugger;
        newLabel.focus();
      }
      variantElement.remove();

      // --- BIS FIX (Change 1 cont.): re-attach it if the freshly fetched
      // server HTML didn't already include it.
      /*if (bisButton && !newVariantElement.querySelector('#BIS_trigger')) {
        const newForm = newVariantElement.querySelector('[data-product-form]');
        if (newForm) newForm.appendChild(bisButton);
      }*/

      if (sizeSoldOutInfo) {
        const existingNew = newVariantElement.querySelector('.size-sold-out-info');
         //console.log("existingNew: ", existingNew);
         //console.log("sizeSoldOutInfo: ", sizeSoldOutInfo);
        if (existingNew) {
          // replace the server's default node with the one carrying your state
          existingNew.replaceWith(sizeSoldOutInfo);
        } else {
          //debugger;
          const newForm = newVariantElement.querySelector('[data-product-form]');
          if (newForm) newForm.appendChild(sizeSoldOutInfo);
          //console.log("newForm: ", newForm);
         // debugger;
        }
      }

      imageElement.parentNode.insertBefore(newImageElement, imageElement);
      imageElement.remove();
    }
    window.scrollTo(0, windowScroll);
    new theme.AjaxProduct(document.querySelector('form[action="/cart/add"]'));
    console.log("Loading Kiwi Sizing Chart");
    typeof loadKiwiSizingChart == 'function' ? loadKiwiSizingChart() : '';
    typeof theme.collapsibles.init == 'function' ? theme.collapsibles.init() : ''; 
    //StampedFn.loadBadges();
    window.history.replaceState({"variantUpdate": "true"},"",`${url}${newVariantId ? `?variant=${newVariantId}` : ""}`);
    // --- BIS FIX (Change 4): after a color change, `.product-section` is
    // fully replaced, so the original `productElement` variable now points
    // to a detached node. Re-query the live DOM so updateVariantState (and
    // therefore updateCartButton's BIS show/hide) reads the correct,
    // currently-checked variant instead of stale data.
    const currentProductElement = document.querySelector(".product-section");
    this.updateVariantState(currentProductElement, clickedInput);

    this.updateVariantKeyHandler();

    } finally {
      // --- BIS FIX (Change 5 cont.): always release the guard, even if
      // something above throws, so the swatch isn't permanently stuck.
      this._updatingVariant = false;
    }
  }
  updateVariantState(productElement, clickedInput) {
    fetch(`${location.pathname}.js`)
      .then((res) => res.json())
      .then((product) => {
        const currentVariant = this.getVariantFromOptions(productElement, product)[0];
        if (currentVariant?.id) {
          fetch(`/variants/${currentVariant.id}.js`) 
            .then((res) => res.json())
            .then((freshVariant) => {
              /*console.log("product: ", product);
              console.log('product.js variant:', currentVariant);
              console.log('fresh variant:', freshVariant);
              console.log('product.js qty:', currentVariant.inventory_quantity);
              console.log('fresh qty:', freshVariant.inventory_quantity);*/
              // Everything that needs variant data goes inside here
              this.updateCartButton(freshVariant, productElement);
              this.updateIdInput(freshVariant, product.id);
              this.updateHoverATC_IMG(product);
              const label = document.querySelector(`label[for="${clickedInput.id}"]`);
              if (label) {
                label.focus();
              } else {
                clickedInput.focus();
              }

              this.updateSwatchAvailability();
            });
        } else {
          // No variant found — still need to handle focus and availability

          console.log("here is the product: ", product);
          console.log("here is the product featured img: ", product.featured_image);
          this.updateCartButton(currentVariant, productElement);
          this.updateIdInput(currentVariant, product.id);
          this.updateHoverATC_IMG(product);

          const label = document.querySelector(`label[for="${clickedInput.id}"]`);
          if (label) {
           // debugger;
            label.focus();
          } else {
           // debugger;
            clickedInput.focus();
          }

          this.updateSwatchAvailability();
        }
        

        const productSEO = document.querySelector("[product_SEO]").getAttribute("product_SEO");
        //console.log("productSEO: ", productSEO);
        if(productSEO != null && productSEO != ""){
          const productSEO_W_StoreName = productSEO + " - Woolx";
          document.title = productSEO_W_StoreName;
        }else{
          const productSEO_W_StoreName = product.title + " - Woolx";
          document.title = productSEO_W_StoreName;
        }

    });
  }
  getVariantFromOptions(productElement, product) { 
    const optionsArray = JSON.stringify(
      Array.from(
        productElement.querySelectorAll("[data-dynamic-variants-enabled] .variant-wrapper fieldset input:checked")
      ).map((element) => element.value)
    );
   
    return product.variants.filter((variant) => {
      const arrayString = JSON.stringify(variant.options);
      if (arrayString == optionsArray) {
        return variant;
      }
    });
  }
  
  // New method to update swatch availability states  
  updateSwatchAvailability() {
    const colorSwatches = document.querySelectorAll('.color-swatch');
    colorSwatches.forEach((swatch) => {
      const input =
        swatch.previousElementSibling ||
        swatch.parentElement.querySelector('input[type="radio"]');
      if (!input || input.name !== "Color") return;
      let url = location.pathname;
      if (input.dataset.optionUrl !== undefined) {
        url = input.dataset.optionUrl;
      }
      // Get current product data
      fetch(`${url}.js`)
        .then((res) => res.json())
        .then((product) => {
          

          const colorValue = input.value;

          // Find the color option index
          let colorIndex = 0;
          product.options.forEach((option, index) => {
            if (
              option.name.toLowerCase().includes("color") ||
              option.name.toLowerCase().includes("colour")
            ) {
              colorIndex = index;
            }
          });
         
          // Check if this color has any available variants
          const hasAvailableVariants = product.variants.some((variant) => {
            return (
              variant.options[colorIndex] === colorValue && variant.available
            );
          });
        });
    });
  }
  disableCartButton() {
    const cartBtn = document.querySelector("[data-add-to-cart]");
    const cartForm = document.querySelector(".product-single__form");
    //console.log("disableCartbutton");
    //console.log("NBIS: ", cartBtn.classList.contains("NBIS"));
    //debugger;
    if(!cartBtn.classList.contains("NBIS")){
       cartForm.style.cursor = "pointer";
    }
   
    cartBtn.classList.add("await");
    cartBtn.style.pointerEvents = "none";
  }
  enableCartbutton(element) {
    const cartBtn = element.querySelector("[data-add-to-cart]");
    cartBtn.classList.remove("await");
    console.log("enableCartbutton");
    cartBtn.style.pointerEvents = "all";
    cartBtn.style.cursor = "pointer !important";
  }

  async refreshProductData(productUrl) {
    const res = await fetch(productUrl); 
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    // Find the script tag that sets window.productData
    const script = doc.querySelector('#product-inventory-script');
    //console.log("Script:", script);

    if (script) {
      eval(script.textContent);
    } else {
      console.warn('product-data-script not found in fetched HTML');
    }
  }

  async updateCartButton(variant, productElement) {
    //document.title = "Testing the document title change";
    //console.log("updateCartButton");
    const cartBtn = document.querySelector("[data-add-to-cart]");
    const outOfStockBtn = document.querySelector("back-instock");
    const cartBtnText = document.querySelector("[data-add-to-cart-text]");
    const disabledButtons = document.querySelectorAll('[aria-disabled="true"]');
    const idSelectOptions = document.querySelectorAll('[name="id"] option');
    const ATC_form = document.querySelector('.product-single__form');

    //console.log("ProductElement: ", productElement);
    //console.log("Updating cart button for variant:", variant);

    disabledButtons.forEach(function (btn) {
      //btn.setAttribute("tabindex", -1);
    });
    if (!cartBtn) return;
    if (variant) {
      
      idSelectOptions.forEach(function (option) {
        if ((option.value = variant.id)) {
          option.selected = true;
        } else {
          option.removeAttribute("selected"); 
        }
      });

      //debugger;
      if (variant.available) {

        // Available, enable the submit button and change text
        document
          .querySelectorAll(".shopify-payment-button__button")
          .forEach(function (elem) {
            elem.removeAttribute("disabled");
            elem.setAttribute("aria-disabled", false);
          });
       
        if(outOfStockBtn !== null ){
          outOfStockBtn.classList.add('hide');
        }

        // --- BIS FIX (Change 3): variant is in stock, so the BIS
        // "Notify Me" button should not be visible. The node is preserved
        // across swaps now, so we must explicitly hide it here.
        /*const bisBtn = document.querySelector('#BIS_trigger');
        if (bisBtn) bisBtn.style.display = 'none';*/
      
        
        const show_variant_title_on_add_cart_button = document.querySelector(
          "#show_variant_title_on_add_cart_button"
        ).value;
        if (show_variant_title_on_add_cart_button != "false") {

          await this.refreshProductData(window.location.pathname);

          const Variant_ID = variant.id;
          //console.log("variant: ", variant);
          //console.log("Variant ID: ", Variant_ID);
          const accurateInventory = window.productData.variants.find(v => v.id === Variant_ID);
          const ProductTitleElement = document.querySelector(".product-single__title");
          const ProductTitle = ProductTitleElement.innerHTML;

          //console.log("Product Title: ", ProductTitle);

          const inventory = accurateInventory?.inventory_quantity;
          const title = accurateInventory?.title;

          const sizeAndColor = title.split("\/");

          const product_ID = accurateInventory?.product_id;
          //debugger;
          //const sellingFastBadge = document.querySelector(".SellingFastBadge");

          if(cartBtn.getAttribute("inventory_threshold") >= inventory && product_ID != 6642470341){ 
            cartBtnText.textContent = "ONLY " + inventory + " LEFT! - ADD TO CART";
            cartBtn.setAttribute("aria-label", `Add the ${ProductTitle}, ${sizeAndColor[0]}color,${sizeAndColor[1]} size to the cart. only ${inventory} left!`)
            //sellingFastBadge.style.display = "flex";
          }else{
            //sellingFastBadge.style.display = "none";
            cartBtnText.textContent = "ADD TO CART";
            cartBtn.setAttribute("aria-label", `Add the ${ProductTitle}, ${sizeAndColor[0]}color,${sizeAndColor[1]} size to the cart`)
          }
          



          cartBtn.classList.remove("disabled");
          
          cartBtn.style.cursor = "pointer !important";
          cartBtn.style.pointerEvents = "all";
          
          cartBtn.classList.remove("await");
          cartBtn.disabled = false;
          disabledButtons.forEach(function (btn) {
            btn.setAttribute("tabindex", 0);
          });
          
          this.updateSizeDisplay();
          this.updateHoverATC();
        } else {
          console.log("else statement");
          var defaultText = cartBtnText.dataset.defaultText; 
          cartBtnText.textContent = defaultText;
        }
       
       
      } else {
        cartBtn.style.pointerEvents = "none";

        //console.log("NBIS: ", cartBtn.classList.contains("NBIS"));
        if(!cartBtn.classList.contains("NBIS")){
          ATC_form.style.cursor = "pointer"; 
        }
          
      
        //console.log("Unavailable");
        this.updateHoverATC();
        document
          .querySelectorAll(".shopify-payment-button__button")
          .forEach(function (elem) {
            elem.setAttribute("disabled", true);
             elem.setAttribute("aria-disabled", true);
          });
        if(outOfStockBtn !== null){
          outOfStockBtn.classList.remove("hide");
        }
        cartBtn.classList.remove("await");
        if(document.querySelector("[data-add-to-cart-text]").getAttribute("data-default-text") == "" ){
          cartBtnText.textContent = theme.strings.soldOut;
        }else{
          cartBtnText.textContent = document.querySelector("[data-add-to-cart-text]").getAttribute("data-default-text");
        }

        // --- BIS FIX (Change 3): variant is out of stock, so the BIS
        // "Notify Me" button should be visible again after the swap.
        /*const bisBtn = document.querySelector('#BIS_trigger');
        if (bisBtn) bisBtn.style.display = '';*/
        
      }

      const sectionId = document.querySelector('[data-section-id]')?.dataset.sectionId;

      fetch(`${window.location.pathname}?variant=${variant.id}&section_id=${sectionId}`)
        .then(res => res.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newBtn = doc.querySelector('#AddToCart');
          const currentBtn = document.querySelector('#AddToCart');
          if (newBtn && currentBtn) currentBtn.replaceWith(newBtn);
        });
     
       
    } else {
      // When no variant is found, update the size display to show no selection
      this.updateSizeDisplay();
      this.updateHoverATC();
      
      // The variant doesn't exist, disable submit button
      document
        .querySelectorAll(".shopify-payment-button__button")
        .forEach(function (elem) {
          elem.setAttribute("disabled", true);
        });
      cartBtn.classList.remove("await");
      cartBtnText.textContent = theme.strings.selectasize;
    }
   // debugger;
    //debugger;
       let jumplinkElement = document.getElementById("stylitics-jumplink");
        const styliticsContainer = document.querySelector(".stylitics-ui-heading");
        debugger;
        if(styliticsContainer){
          debugger;
          jumplinkElement.style.visibility = "visible";

          jumplinkElement.addEventListener("click", function (event) { 

            const rect = styliticsContainer.getBoundingClientRect();

            const styliticsHeading = document.querySelector(".stylitics-ui-heading");
            
            const absoluteTop = rect.top + window.pageYOffset - 175; 

            window.scrollTo({
              top: absoluteTop,
              behavior: 'smooth'
            });
            styliticsHeading.focus();
          });
        }
  }

  async showSoldOutInfo() {
    const sizeSoldOutInfo = document.querySelector('.size-sold-out-info');
    sizeSoldOutInfo.classList.remove('visibility-hidden');
  }

  async hideSoldOutInfo() {
    const sizeSoldOutInfo = document.querySelector('.size-sold-out-info');
    sizeSoldOutInfo.classList.add('visibility-hidden');
  }

  async updateHoverATC_IMG(product) {
    //debugger;
    const targetImg = document.querySelector('.FloatingATC_Image');
    const desktopProductTitle = document.querySelector(".desktopHoverATC_Title");
     
    //console.log("targetImage: ", targetImg);
    //console.log("FeatureIMG: ", product.featured_image);

    
    desktopProductTitle.innerText = product.title;

    targetImg.src = product.featured_image;
    //debugger;
  }


  async updateHoverATC() {
    const hoverATC = document.querySelector('.ATC_redirectContainer_text');
    const hoverATC_Desktop = document.querySelector('.ATC_redirectContainer_text_Desktop');
    const ATC_redirectContainer_Desktop = document.querySelector('.ATC_redirectContainer_Desktop');
    const ATC_redirectContainer_text_Desktop = document.querySelector('.ATC_redirectContainer_text_Desktop');
    const ATC_redirectContainer = document.querySelector('.ATC_redirectContainer');
    const ATC_redirectContainer_text = document.querySelector('.ATC_redirectContainer_text');
    const sizeSelected = document.querySelector('#SelectedSize');
    const ATC = document.querySelector('#AddToCart');
    const colorPatternImage = sizeSelected.getAttribute('color-pattern-image');
    const colorImage = sizeSelected.getAttribute('color-image');
    ATC_redirectContainer.style.visibility = "hidden";

    //console.log("updateHoverATC");

    if (colorPatternImage === "No Image" || colorImage === "No Image") {
      hoverATC.style.background = "black";
      hoverATC.style.color = "white";
      
      hoverATC_Desktop.style.background = "black";
      hoverATC_Desktop.style.color = "white";
    } else {
      hoverATC.style.background = `url('${colorPatternImage}') center / cover no-repeat, url('${colorImage}') center / cover no-repeat`;
      hoverATC.style.backgroundRepeat = "no-repeat";
      hoverATC.style.backgroundSize = "5000px";
      hoverATC.style.color = ATC.style.color;

      hoverATC_Desktop.style.background = `url('${colorPatternImage}') center / cover no-repeat, url('${colorImage}') center / cover no-repeat`;
      hoverATC_Desktop.style.backgroundRepeat = "no-repeat";
      hoverATC_Desktop.style.backgroundSize = "5000px";
      hoverATC_Desktop.style.color = ATC.style.color;
    }

    // Disconnect the old observer before creating a new one
    if (window._observer_ATC) {
      window._observer_ATC.disconnect();
    }

    let isFirstFire = true; // 👈 flag to skip the initial callback

    window._observer_ATC = new IntersectionObserver((entries) => {
      if (isFirstFire) {
        isFirstFire = false;
        return; // 👈 skip the initial fire, visibility already set above
      }

      entries.forEach(entry => {
        const ATC_text = document.querySelector('.ATC_text');
        ATC_redirectContainer_text.textContent = ATC_text.textContent;

        //console.log("ATC text: ", ATC_text.textContent);
        if(ATC_text.textContent.includes("Coming Soon")){
          console.log("True");
          ATC_redirectContainer_text_Desktop.textContent = "SELECT A SIZE";
        }else{
          console.log("false");
          ATC_redirectContainer_text_Desktop.textContent = ATC_text.textContent; 
        }

        
        const ATC = document.querySelector('#AddToCart');
        const ATC_Position = ATC.getBoundingClientRect();
        if (!entry.isIntersecting) {

          //console.log("Scroll y:",  window.scrollY);
          if (window.scrollY >= ATC_Position.bottom) {
            console.log("set visible");
            ATC_redirectContainer_Desktop.style.visibility = 'visible';
          }
          
          
          ATC_redirectContainer.style.visibility = 'visible';
          
          
        } else {
          ATC_redirectContainer_Desktop.style.visibility = 'hidden';
          ATC_redirectContainer.style.visibility = 'hidden';
        }
      });
    });

    window._observer_ATC.observe(document.querySelector('#AddToCart'));
  }

  // New method to handle size display updates
  async updateSizeDisplay() {
    const sizeDisplayElements = document.querySelectorAll(".optionSize");
    const checkedSizeInput = document.querySelector('.variant-wrapper fieldset input[name="Size"]:checked');
    const sizeSelected = document.querySelector('#SelectedSize');
    const ATC = document.querySelector('#AddToCart');
    const sizeLabel = document.querySelector('.optionSize');
    const ATC_Text = document.querySelector(".ATC_text");
    
    //console.log("SizeLabel: ",sizeLabel);

    const colorPatternImage = sizeSelected.getAttribute('color-pattern-image');
    const colorImage = sizeSelected.getAttribute('color-image');
    //debugger;
    if(ATC_Text.textContent.includes("Select")){
       sizeSelected.previousElementSibling.removeAttribute("checked");
    }else{
      sizeSelected.setAttribute("checked", "checked");
      sizeSelected.previousElementSibling.removeAttribute("NoSizeChecked");
      if(sizeLabel !== null){
        sizeLabel.classList.remove("noShow");
      }
      

      if(colorPatternImage === "No Image" || colorImage === "No Image"){
        sizeSelected.style.background = "black";
        sizeSelected.style.color = "white";
      }else{
        sizeSelected.style.background = `url('${colorPatternImage}') center / cover no-repeat, url('${colorImage}') center / cover no-repeat`;
        sizeSelected.style.backgroundRepeat = "no-repeat";
        sizeSelected.style.backgroundSize = "100px";
      }

      


      //console.log("color pattern image: ", colorPatternImage);
      //console.log("color image: ", colorImage);
        
        // testing if the URL is valid
      const BackupIMG = ATC.getAttribute('backup-backgroundImg');
      const URLExists = await this.testImageUrl(BackupIMG);
      let targetIMG = "";
      if(URLExists){
        
        targetIMG = BackupIMG;
      }else{
        targetIMG = ATC.getAttribute('backgroundImg');
      }
      const { hex } = await this.getHexFromUrl(targetIMG, 10, 20);

      let TextColor;
      TextColor = this.getTextColorFromHex(hex);

      sizeSelected.style.color = TextColor;
      ATC.style.color = TextColor;
    }

    

    

   

    sizeDisplayElements.forEach((element) => {
      element.textContent = checkedSizeInput ? checkedSizeInput.value : "";
    });
  }

  testImageUrl(url) {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = url;
    });
  }

  getTextColorFromHex(hex) {
    const rgb = hex.replace('#', '');
    const r = parseInt(rgb.substring(0, 2), 16) / 255;
    const g = parseInt(rgb.substring(2, 4), 16) / 255;
    const b = parseInt(rgb.substring(4, 6), 16) / 255;

    const luminance =
      0.2126 * r +
      0.7152 * g +
      0.0722 * b;

    return luminance > 0.6 ? 'black' : 'white';
  }

  getHexFromUrl(url, x = 0, y = 0) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';

      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);

        // Primary pixel (used for solid color fallback)
        const [r, g, b] = ctx.getImageData(x, y, 1, 1).data;
        const hex = '#' + [r, g, b].map(v => v.toString(16).padStart(2, '0')).join('');

        // Pattern detection — sample pixels across the image
        const SAMPLE_COUNT = 30;
        const TOLERANCE = 50;
        const sampledColors = new Set();

        for (let i = 0; i < SAMPLE_COUNT; i++) {
          const sx = Math.floor((img.width / SAMPLE_COUNT) * i);
          const sy = Math.floor((img.height / SAMPLE_COUNT) * i);
          const [sr, sg, sb] = ctx.getImageData(sx, sy, 1, 1).data;
          const bucketed = [sr, sg, sb].map(v => Math.round(v / TOLERANCE) * TOLERANCE).join(',');
          sampledColors.add(bucketed);
        }
        const isPattern = sampledColors.size > 2;

        resolve({ hex, isPattern, distinctColorCount: sampledColors.size });
      };

      img.onerror = reject;
      img.src = url;
    });
  }

  updateIdInput(variant, productId) {
    const form = document.querySelector(`form[data-product-id="${productId}"]`);
    if (variant != undefined) {
        form.querySelectorAll('[name="id"]').forEach(function(elem) {
        elem.value = variant.id;
      });
      document.querySelector(`[data-product-select]`).dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}
customElements.define("variant-button", VariantButton);
